import {
  CATEGORY,
  SIGN_OUT,
} from '../actions/constants';

const initialState = {
  handling: false,
  data: {},
};

export default function category(state = initialState, action) {
  switch (action.type) {
    case CATEGORY.handlers.fetch:
    case CATEGORY.handlers.update:
    case CATEGORY.handlers.import:
    case CATEGORY.handlers.remove:
      return {
        ...state,
        handling: true,
      };
    case CATEGORY.update:
      return {
        ...state,
        data: action.merge ? {
          ...state.data,
          ...action.data,
        } : action.data,
        handling: false,
      };
    case SIGN_OUT:
      return initialState;
    default:
      return state;
  }
}
